import {
	Component,
	OnInit
} from '@angular/core';
import {
	AvlaGenericComponent,
	MessageService,
	I18nService,
	InfoMessageDTO
} from "shared-angular-components-avla";
import {
	AuthService,
	AvlaRestClientService
} from "base-angular-avla";
import {
	Router
} from "@angular/router";

declare var $:any;

@Component({
	selector: 'dev-component',
	templateUrl: './dev.component.html',
	providers: [
		I18nService
	],
})
export class DevComponent extends AvlaGenericComponent implements OnInit {
	constructor(
		protected restClientService: AvlaRestClientService,
		protected messageService: MessageService,
		protected authService: AuthService,
		protected i18n: I18nService,
		protected router: Router,
	) {
		super(restClientService, messageService, router, authService, i18n);
	}

	ngOnInit() {
		if (this.isDevelop) {
			setTimeout(() => {
				console.log("setTimeout en dev.component");
				this.showMesaggeDevelop();
			}, 2500);
		}
	}

	private helpShowed = false;
	private static get TIME_SECONDS_SHOW_HELP() {return 10;};

	public get isDevelop() {
		if (window && Array.isArray(window['serverApiUrl'])) {
			for (let serverApiUrlTemp of window['serverApiUrl']) {
				if (serverApiUrlTemp.indexOf('/dev_') > -1) {
					return true;
				}
			}
		}
		else {
			if (window && window['serverApiUrl'].indexOf('/dev_') > -1) {
				return true;
			}
		}
		return false;
	}



	public showMesaggeDevelop() {
		if (this.helpShowed) {
			return;
		}
		this.messageService.announcedMessage(
			new InfoMessageDTO(
				'warning',
				'<h5>' + this.i18n.getTranslation('ASCFC_DevComponent_ALERT_1') + '</h5><br>' +
				'<b>' + this.i18n.getTranslation('ASCFC_DevComponent_ALERT_2') + '</b>',
				DevComponent.TIME_SECONDS_SHOW_HELP * 1000));
		this.helpShowed = true;
		setTimeout(() => {
			console.log("setTimeout 2 en help.component");
				this.helpShowed = false;
		}, DevComponent.TIME_SECONDS_SHOW_HELP * 1000);
	}

}
